module.exports = __webpack_public_path__ + "img/evse_item-v2_38x38.c6cdca92.svg";